import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

export const SearchInputWrapper = styled.div`
  width: 100%;
  flex: 1;
  border-radius: 8px;
  overflow: hidden;
  margin-right: 15px;
`;

export const SearchDateWrapper = styled.div`
  width: 330px;
  margin-right: 15px;
  border-radius: 8px;
  overflow: hidden;
`;
